import RootRef from './RootRef';

export default RootRef;



// WEBPACK FOOTER //
// ./src/rootRef/index.js